// src/utils/startPayUPayment.js
export async function startPayUPayment({ cartItems, shippingData, shippingMethod, discountCode, language }) {
    const API_URL = process.env.REACT_APP_API_URL;

    // Only ids and quantities matter: the backend re-prices everything
    // (products, discount, shipping) and records the order lines itself.
    const items = cartItems.map((item) => ({
        id: item.id,
        documentId: item.documentId,
        quantity: Number(item.quantity ?? 1),
    }));

    const res = await fetch(`${API_URL}/payu/create-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, shippingMethod, shippingData, discountCode, language }),
    });

    const data = await res.json().catch(() => null);
    if (!res.ok) {
        const error = new Error(data?.error || 'PayU error');
        error.status = res.status;
        error.outOfStock = data?.outOfStock;
        throw error;
    }

    if (!data?.redirectUri) {
        throw new Error('PayU error');
    }

    window.location.href = data.redirectUri;
}
